// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3l1o8","errors":"Errors_errors__2KvCo"};